/* eslint-disable @typescript-eslint/naming-convention */
import React, { useMemo } from 'react'
import { makeStyles } from '@material-ui/core'

const jss = (t) => {
    const { colors } = t['foundations-library']
    return {
        barsContainer: {
            display: 'flex',
            gap: '11px'
        },
        bar: {
            border: `2.5px solid ${colors.neutral[50]}`,
            borderRadius: '3px'
        },
        completed: {
            borderColor: ({ color }) => colors[color][500],
            transition: 'border-color 0.3s ease-in-out'
        }
    }
}

const useStyles = makeStyles(jss)

interface PropsInterface {
    total: number,
    completed: number,
    color?: string,
    className?: string
}

/**
 *
 */
const PasswordStrengthBar = ({ total, completed, className = '' }: PropsInterface): JSX.Element => {
    const color = useMemo(() => {
        const percentageCompleted = (completed / total) * 100
        if (percentageCompleted <= 40) {
            return 'destructive'
        }
        if (percentageCompleted === 100) {
            return 'primary'
        }

        // return 'primary2'
        return 'tertiary'
    }, [completed, total])
    const styles = useStyles({ color })

    return <div className={`${styles.barsContainer} ${className}`}>
        {Array.from({ length: total }, (_, index) => (
            <div
                key={index}
                className={`${styles.bar} ${index < completed ? styles.completed : ''}`}
                style={{
                    width: `${100 / total}%`
                }}
                data-testid={`bar-${index + 1}`}
            />
        ))}
    </div>
}

export default PasswordStrengthBar
